import { useCallback } from 'react';

import {
  useLazyGetCustomListQuery,
  usePostCustomListMutation,
} from '../../../../features/ChatModule';
import { type EndpointBlock } from '../../../types';

const useGetSelectOptions = () => {
  const [fetchGetList, { isError: isGetError, isLoading: isGetLoading }] =
    useLazyGetCustomListQuery();
  const [fetchPostList, { isError: isPostError, isLoading: isPostLoading }] =
    usePostCustomListMutation();

  const handlePostList = useCallback(
    async ({ url, payload, queryParams }: EndpointBlock) => {
      try {
        const response = await fetchPostList({
          url,
          data: payload ?? {},
          queryParams,
        }).unwrap();

        return response;
      } catch (error) {
        throw Error(JSON.stringify(error));
      }
    },
    [fetchPostList]
  );

  const handleGetList = useCallback(
    async ({ url, queryParams }: EndpointBlock) => {
      try {
        const response = await fetchGetList({
          url,
          data: queryParams ?? {},
        }).unwrap();

        return response;
      } catch (error) {
        throw Error(JSON.stringify(error));
      }
    },
    [fetchGetList]
  );

  return {
    handlePostList,
    isPostError,
    isPostLoading,
    handleGetList,
    isGetError,
    isGetLoading,
  };
};

// eslint-disable-next-line import/prefer-default-export
export { useGetSelectOptions };
